module.exports = __webpack_public_path__ + "media/icons/opony-title-blue@3x-f73b7083.svg";